import { useEffect, useRef, useState } from 'react';

export const ProductActionDropdown = ({ product, onAction }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState('right');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Calculate dropdown position when opening
    if (isOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const spaceOnRight = window.innerWidth - rect.right;
      
      // If less than 200px space on right, position to the left
      if (spaceOnRight < 200) {
        setDropdownPosition('left');
      } else {
        setDropdownPosition('right');
      }
    }
  }, [isOpen]);

  const handleAction = (action) => {
    console.log('🎯 ProductActionDropdown: Action triggered:', action, 'for product:', product?.name);
    console.log('📦 Product data:', product);
    
    setIsOpen(false);
    
    if (onAction && product) {
      onAction(product, action);
    } else {
      console.error('❌ Missing onAction handler or product data');
    }
  };

  if (!product) {
    console.error('❌ ProductActionDropdown: No product provided');
    return null;
  }

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button 
        className="text-gray-400 hover:text-gray-600 p-1 rounded transition-colors"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
          console.log('🔄 ProductActionDropdown: Toggle dropdown', !isOpen);
        }}
        aria-label="Product actions"
      >
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
        </svg>
      </button>

      {isOpen && (
        <div className={`absolute ${dropdownPosition === 'left' ? 'right-full mr-2' : 'right-0'} mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50`}>
          <div className="py-1">
            <button
              onClick={() => handleAction('edit')}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
            >
              <svg className="w-4 h-4 mr-3 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              Edit
            </button>
            
            <button
              onClick={() => handleAction('restock')}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
            >
              <svg className="w-4 h-4 mr-3 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Restock
            </button>
            
            <button
              onClick={() => handleAction('hide')}
              className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
            >
              <svg className="w-4 h-4 mr-3 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Hide
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductActionDropdown;